export enum AssistantChatWindowType {
    sidePanel = 'sidePanel',
    sideBar = 'sideBar',
}
